import { snackBarError } from '#action/fetch';
import { webPortalApi } from '#config/web-portal-api';
import { SET_TABLE_CONFIG, UPDATE_TABLE_CONFIG, CLEAR_TABLE_CONFIG } from '#action/types';
import defaultColumns from '#component/table/configurable-table/default-columns';
import { getRequestOptions } from '#helper';

const setTableConfig = (config, key) => ({
  type: SET_TABLE_CONFIG,
  payload: { config, key }
});

const updateTableConfig = config => ({
  type: UPDATE_TABLE_CONFIG,
  payload: config
});

export const clearTableConfig = () => ({
  type: CLEAR_TABLE_CONFIG
});

export const getTableConfig = key => async dispatch => {
  try {
    const searchParams = new URLSearchParams({ key });
    const url = webPortalApi.buildApiUrl(`user/storage?${searchParams.toString()}`);
    const res = await fetch(url, getRequestOptions());
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    if (!res.ok) {
      throw new TypeError('Error in request');
    }

    const data = await res.json() || {};
    const defaultTable = defaultColumns[key];
    let tableConfig = Object.keys(data).length === 0 ? defaultTable : data[key];

    if (Object.keys(defaultTable ?? {})?.length !== Object.keys(tableConfig ?? {})?.length) {
      tableConfig = defaultTable.map(defaultItem => {
        const override = tableConfig.find(cfg => cfg.id === defaultItem.id) || {};
        return {
          ...defaultItem,
          ...override
        };
      });
    }

    dispatch(setTableConfig(tableConfig, key));
  } catch (error) {
    dispatch(snackBarError({
      message: 'Error in request',
      ...error
    }));

    dispatch(setTableConfig(defaultColumns[key], key));
  }
};

export const patchTableConfig = (key, config) => async dispatch => {
  try {
    dispatch(updateTableConfig(config));

    const data = { key, value: JSON.stringify(config) };
    const res = await fetch(webPortalApi.buildApiUrl('user/storage'), {
      method: 'PATCH',
      body: JSON.stringify(data),
      ...getRequestOptions()
    });

    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }
  } catch (error) {
    dispatch(snackBarError({
      message: 'Error in request',
      ...error
    }));
  }
};
